import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { colors } from '../theme/colors';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
  className = ''
}) => {
  return (
    <>
      <Container className="p-2 mt-3" style={{
        border: `1px solid ${colors.stroke}`,
        borderBottom: 'none',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
      }}>
        <Row>
          <div className="m-0 font-size-medium" style={{
            paddingLeft: 30
          }}>{title}</div>
        </Row>
      </Container>
      <Container className={`formContainer ${className}`} style={{
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}>
        {children}
      </Container>
    </>
  );
}; 